<script>
import { mapGetters } from 'vuex';
import TabGroup from '../Tabs/TabGroup.vue';
import RacingOddsComparisonTableDesktop from './RacingOddsComparisonTableDesktop.vue';
import Pusher from '../../plugins/Pusher';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator.vue';

export default {
  name: 'RacingOddsComparisonTable',
  components: {
    RacingOddsComparisonTableDesktop,
    TabGroup,
    LoadingIndicator,
  },
  props: {
    slug: {
      type: String,
      default: null,
    },
    eventNumber: {
      type: String,
      default: null,
    },
    preselectedTab: {
      type: Number,
      default: 0,
    },
    eventId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      viewportWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters({
      ocTables: 'RacingOddsComparisonTable/getData',
      betType: 'RacingOddsComparisonTable/getBetType',
      ocOdds: 'RacingOddsComparisonTable/getOdds',
      storeEventId: 'RacingOddsComparisonTable/getEventId',
    }),
    matchedEvent() {
      const { ocTables, storeEventId } = this;
      // filter out the event which has same eventId as the one injected through props
      const eventArray = ocTables.events.filter(e => e.id === storeEventId);
      if (this.betType === 'FixedPlace') {
        return eventArray.find(e => e.isPlace);
      }
      return eventArray[0];
    },
  },
  async beforeMount() {
    const {
      eventId,
      $store: store,
      betType,
      slug,
      eventNumber,
      storeEventId,
      initFuncWithEventIdAsParam,
      initFuncWithMeetingSlugAsParam,
    } = this;
    if (eventId) {
      await store.dispatch('RacingOddsComparisonTable/fetchEventDataById', { eventId, betType });
    } else {
      await store.dispatch('RacingOddsComparisonTable/fetchEventDataBySlug', { slug, eventNumber, betType });
    }
    // eventId as param

    if (!window.pusher) {
      // Open a connection to Pusher
      const APP_KEY = 'cf89e08266e360e56843';
      window.pusher = new Pusher(APP_KEY);
    }
    if (storeEventId) {
      initFuncWithEventIdAsParam(storeEventId);
    } else {
      initFuncWithMeetingSlugAsParam();
    }
  },
  methods: {
    // for sport related page
    async initFuncWithMeetingSlugAsParam() {
      const { events } = this.ocTables;
      const { $store: store } = this;

      for (const event of events) {
        if (event && window.pusher) {
          // Subscribe to event channel
          window.pusher.subscribeToEventChannel(event.id, store);
        }
      }
    },
    // for racing related page
    async initFuncWithEventIdAsParam(eventId) {
      // Subscribe to event channel
      if (window.pusher) {
        window.pusher.subscribeToEventChannel(eventId, this.$store);
      }
    },
  },
};
</script>

<template>
  <div>
    <div v-if="storeEventId && matchedEvent" class="odd-table--event-id-as-param">
      <div class="odds-comparison-table">
        <RacingOddsComparisonTableDesktop
          v-if="viewportWidth >= 760"
          :table-data="matchedEvent"
          :odds="ocOdds"
          :bet-type="betType"
          :key="betType"
          :event-id="storeEventId"
        />
      </div>
    </div>
    <template v-else>
      <LoadingIndicator />
    </template>
  </div>
</template>
